export const environment = {
    production: false,
    saveState: true,
    recaptcha: {
        siteKey: '6Le9nccoAAAAAAx9c4YJ9ntYwvNX8VE0jgHykDtg'
    },
    captchaToggleAllowed: true
};
